import { apiService } from '../core/ApiService.js';
import { AuthModal } from './AuthModal.js';
import { i18n } from '../utils/I18n.js';

export class LeaderboardModal {
    constructor() {
        this.container = null;
        this.authModal = null;
    }

    create() {
        const existing = document.getElementById('leaderboardModal');
        if (existing) {
            this.container = existing;
            return;
        }

        const modal = document.createElement('div');
        modal.id = 'leaderboardModal';
        modal.innerHTML = `
            <div class="lb-modal-content">
                <button class="lb-close-btn">&times;</button>
                <h2 class="lb-title" data-i18n="leaderboard.title">Leaderboard</h2>
                <div class="lb-header">
                    <span class="lb-col-rank" data-i18n="leaderboard.rank">#</span>
                    <span class="lb-col-player" data-i18n="leaderboard.player">Player</span>
                    <span class="lb-col-time" data-i18n="leaderboard.time">Time</span>
                    <span class="lb-col-date" data-i18n="leaderboard.date">Date</span>
                </div>
                <div class="lb-list" id="lbList">
                    <div class="lb-loading" data-i18n="leaderboard.loading">Loading...</div>
                </div>
                <div class="lb-login-section" id="lbLoginSection">
                    <p class="lb-login-hint" data-i18n="leaderboard.login_hint">Login to join the leaderboard~</p>
                    <button class="lb-login-btn" id="lbLoginBtn" data-i18n="leaderboard.login_btn">Login</button>
                </div>
            </div>
        `;

        this._injectStyles();
        document.body.appendChild(modal);
        this.container = modal;

        this.container.querySelector('.lb-close-btn').onclick = () => this.hide();
        this.container.querySelector('#lbLoginBtn').onclick = () => this._showAuthModal();
    }

    _injectStyles() {
        if (document.getElementById('lb-modal-styles')) return;
        const style = document.createElement('style');
        style.id = 'lb-modal-styles';
        style.textContent = `
            #leaderboardModal {
                position: fixed;
                top: 0; left: 0; width: 100%; height: 100%;
                background: rgba(0, 0, 0, 0.7);
                backdrop-filter: blur(5px);
                z-index: 2500;
                display: none;
                align-items: center;
                justify-content: center;
                opacity: 0;
                transition: opacity 0.3s ease;
            }
            #leaderboardModal.visible {
                opacity: 1;
            }
            .lb-modal-content {
                background: #FFF;
                width: 90%;
                max-width: 600px;
                height: 80vh;
                border-radius: 20px;
                padding: 30px;
                position: relative;
                display: flex;
                flex-direction: column;
                box-shadow: 0 10px 40px rgba(0,0,0,0.3);
                transform: translateY(20px);
                transition: transform 0.3s;
            }
            #leaderboardModal.visible .lb-modal-content {
                transform: translateY(0);
            }
            .lb-close-btn {
                position: absolute;
                top: 20px;
                right: 20px;
                font-size: 28px;
                background: none;
                border: none;
                cursor: pointer;
                color: #888;
            }
            .lb-title {
                text-align: center;
                color: #A67C52;
                margin-bottom: 20px;
                font-size: 1.8rem;
            }
            .lb-header {
                display: flex;
                padding: 10px 20px;
                background: #FDF6EC;
                border-radius: 10px;
                font-weight: 600;
                color: #8B7355;
                margin-bottom: 10px;
            }
            .lb-col-rank { width: 50px; text-align: center; }
            .lb-col-player { flex: 1; padding-left: 10px; }
            .lb-col-time { width: 80px; text-align: right; }
            .lb-col-date { width: 100px; text-align: right; display: none; }
            @media(min-width: 500px) { .lb-col-date { display: block; } }

            .lb-list {
                flex: 1;
                overflow-y: auto;
                padding: 0 5px;
            }
            .lb-item {
                display: flex;
                align-items: center;
                padding: 12px 15px;
                border-bottom: 1px solid #EEE;
            }
            .lb-item:last-child { border-bottom: none; }
            
            .lb-rank-badge {
                width: 30px; height: 30px;
                display: flex; align-items: center; justify-content: center;
                border-radius: 50%;
                font-weight: bold;
                margin-right: 20px;
                color: #555;
            }
            .lb-rank-1 { background: #FFD700; color: #FFF; box-shadow: 0 2px 5px rgba(255, 215, 0, 0.4); }
            .lb-rank-2 { background: #C0C0C0; color: #FFF; }
            .lb-rank-3 { background: #CD7F32; color: #FFF; }

            .lb-avatar {
                width: 32px; height: 32px;
                border-radius: 50%;
                margin-right: 10px;
                background: #DDD;
                object-fit: cover;
            }
            .lb-player-name {
                font-weight: 500;
                color: #333;
            }
            .lb-time {
                font-family: monospace;
                font-size: 1.1rem;
                font-weight: 600;
                color: #A67C52;
            }
            .lb-date {
                font-size: 0.8rem;
                color: #999;
            }
            .lb-loading {
                text-align: center;
                padding: 40px;
                color: #999;
            }
            .lb-login-section {
                margin-top: 20px;
                padding: 20px;
                background: linear-gradient(135deg, #FDF6EC 0%, #FAF0E4 100%);
                border-radius: 12px;
                text-align: center;
                border: 1px solid rgba(201, 167, 125, 0.2);
            }
            .lb-login-hint {
                font-size: 0.95rem;
                color: #8B7355;
                margin-bottom: 12px;
                font-weight: 500;
            }
            .lb-login-btn {
                padding: 10px 24px;
                background: linear-gradient(135deg, #C9A77D 0%, #A67C52 100%);
                color: white;
                border: none;
                border-radius: 8px;
                font-family: 'Quicksand', sans-serif;
                font-size: 0.95rem;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 2px 8px rgba(166, 124, 82, 0.25);
            }
            .lb-login-btn:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(166, 124, 82, 0.35);
            }
        `;
        document.head.appendChild(style);
    }

    async show(puzzleId) {
        if (!this.container) this.create();

        this.container.style.display = 'flex';
        this.container.offsetHeight;
        this.container.classList.add('visible');

        // Apply i18n translations
        i18n.applyTranslations();

        // Check if user is logged in
        const currentUser = apiService.getCurrentUser();
        const loginSection = document.getElementById('lbLoginSection');
        if (loginSection) {
            loginSection.style.display = currentUser ? 'none' : 'block';
        }

        const listEl = document.getElementById('lbList');
        listEl.innerHTML = '<div class="lb-loading" data-i18n="leaderboard.loading">Loading...</div>';
        i18n.applyTranslations();

        try {
            const data = await apiService.getLeaderboard(puzzleId);
            this._renderList(data);
        } catch (error) {
            listEl.innerHTML = `<div class="lb-loading" style="color:red" data-i18n="leaderboard.load_error">Failed to load</div>: ${error.message}`;
            i18n.applyTranslations();
        }
    }

    _showAuthModal() {
        if (!this.authModal) {
            this.authModal = new AuthModal((user) => {
                // Login success callback
                const loginSection = document.getElementById('lbLoginSection');
                if (loginSection) {
                    loginSection.style.display = 'none';
                }
            });
        }
        this.authModal.show();
    }

    _renderList(data) {
        const listEl = document.getElementById('lbList');
        if (!data || data.length === 0) {
            listEl.innerHTML = '<div class="lb-loading" data-i18n="leaderboard.no_scores">No scores yet. Be the first!</div>';
            i18n.applyTranslations();
            return;
        }

        listEl.innerHTML = data.map((item, index) => {
            const rank = index + 1;
            let rankClass = '';
            if (rank === 1) rankClass = 'lb-rank-1';
            if (rank === 2) rankClass = 'lb-rank-2';
            if (rank === 3) rankClass = 'lb-rank-3';

            const timeStr = this._formatTime(item.time_ms);
            const dateStr = new Date(item.completed_at * 1000).toLocaleDateString();
            const avatar = item.avatar_url || `https://ui-avatars.com/api/?name=${item.username}&background=random`;

            return `
                <div class="lb-item">
                    <div class="lb-col-rank">
                        <div class="lb-rank-badge ${rankClass}">${rank}</div>
                    </div>
                    <div class="lb-col-player" style="display:flex; align-items:center">
                        <img src="${avatar}" class="lb-avatar" referrerpolicy="no-referrer" onerror="this.src='data:image/svg+xml,<svg...>'">
                        <span class="lb-player-name">${item.username}</span>
                    </div>
                    <div class="lb-col-time">
                        <span class="lb-time">${timeStr}</span>
                    </div>
                    <div class="lb-col-date">
                        <span class="lb-date">${dateStr}</span>
                    </div>
                </div>
            `;
        }).join('');
    }

    _formatTime(ms) {
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    hide() {
        if (!this.container) return;
        this.container.classList.remove('visible');
        setTimeout(() => {
            this.container.style.display = 'none';
        }, 300);
    }
}
